import React from "react";

const userContext = React.createContext();
userContext.displayName = "User Context";

export default userContext;
